import { RegisteredComponent } from "@builder.io/sdk-react";

export const accountStatusMessageBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "Account status message",
  canHaveChildren: true,
  shouldReceiveBuilderProps: {
    builderContext: true,
  },
  inputs: [
    {
      name: "onFinish",
      type: "javascript",
      localized: false,
    },
  ],
};
